import * as React from "react";
import Settings from "./Settings";
import Home from "./Home";
import { Route, Routes } from "react-router-dom";
import Layout from "./Layout";
import "./style.scss";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";

interface AppProps {
  title: string;
}

const App: React.FC<AppProps> = (props: AppProps) => {
  return (
    <>
    <Routes>
      <Route element={<Layout title={props.title} />}>
        <Route path="/" element={<Home />} />
        <Route path="/settings" element={<Settings />} />
      </Route>
    </Routes>
     <ToastContainer position="top-center" autoClose={4000} hideProgressBar />
     </>
  );
};

export default App;
